module.exports = __webpack_public_path__ + "img/lastBlockBg.c4765021.png";